import dayjs from 'dayjs';
import { ICity } from 'app/shared/model/city.model';
import { ActivityType } from 'app/shared/model/enumerations/activity-type.model';

export interface IAdvertisment {
  id?: number;
  fromDate?: dayjs.Dayjs | null;
  toDate?: dayjs.Dayjs | null;
  active?: boolean | null;
  imageurl?: string | null;
  activityType?: keyof typeof ActivityType | null;
  description?: string | null;
  advertismentImageContentType?: string | null;
  advertismentImage?: string | null;
  city?: ICity | null;
}

export const defaultValue: Readonly<IAdvertisment> = {
  active: false,
};
